// Public Auth0 application settings shared by browser login and server verification.
export const AUTH0_DOMAIN = "copagon.eu.auth0.com";
export const AUTH0_CLIENT_ID = "4bjuVtvLvoVp4hNK4QTrN1Jcwy9duVvx";
